import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';

import Button from '../../../../components/Button';
import Icon from '../../../../components/Icon';

// import luftLogo from '../../../../assets/images/luft-digital-white@2x.png';
import luftLogoBeta from '../../../../assets/images/luft-digital-white-beta@2x.png';

import SuggestionModal from './SuggestionModal';
import SelectCompanyModal from '../../../Login/components/SelectCompanyModal';
import { USER_TYPES } from '../../../Admin/shared/static-options';

import './styles.css';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestionsModalVisible: false,
      selectCompanyModalIsVisible: false,
    };
  }
  _checkPageLocationFoDisplayAllInCustomerName() {
    const location = this.props.location.pathname;
    const locations = [
      '/u/travel-monitoring',
      '/u/manifests-in-transit',
      '/u/vehicles',
    ];

    if (locations.includes(location)) {
      return true;
    }

    return false;
  }

  _toggleSuggestionsModal = () => {
    this.setState({
      suggestionsModalVisible: !this.state.suggestionsModalVisible,
    });
  };

  _toggleSelectCompanyModal = () => {
    this.setState({
      selectCompanyModalIsVisible: !this.state.selectCompanyModalIsVisible,
    });
  };

  render() {
    const {
      onMenuClick,
      userType,
      activeCompany,
      onCompanySelect,
      operationalDashboard,
      match,
    } = this.props;

    let isOperationalDashboard = false;

    if (match.url === '/u/dashboard-operacional') {
      isOperationalDashboard = true;
    }

    return (
      <div id="Header" className={classNames('Header', { 'Header-OperationalDashboard': operationalDashboard })}>
        <div className="Header__side">
          <Icon
            className="Header__menu-icon"
            name="menu"
            onClick={onMenuClick}
          />
          <span className="Header__page-title">Menu</span>
        </div>
        <img
          className="Header__logo"
          src={luftLogoBeta}
          alt="Luft Logo"
        />

        {
          isOperationalDashboard &&
          <div className="Header__side Header__side--end">
            <ul className="OperationalDashboard-menu">
              <li><Link to="/u/dashboard-operacional/deposito">Depósito</Link></li>
              <li><Link to="/u/dashboard-operacional/distribuicao">Distribuição</Link></li>
              <li><Link to="/u/dashboard-operacional/veiculos">Veículos</Link></li>
            </ul>
          </div>
        }

        {
          userType !== USER_TYPES.CUSTOMER_SERVICE_USER && !isOperationalDashboard &&
          <div className="Header__side Header__side--end">
            <Button
              className="Header__suggestion-button"
              skin="transparent"
              text="Sugestões"
              icon="chat_bubble"
              textCapitalize
              onClick={this._toggleSuggestionsModal}
            />
            <Icon
              className="Header__menu-icon Header__menu-icon--sm-only"
              name="chat_bubble"
              onClick={this._toggleSuggestionsModal}
            />
          </div>
        }

        {
          userType === USER_TYPES.CUSTOMER_SERVICE_USER && !isOperationalDashboard &&
          <div className="Header__side Header__side--end">
            <Button
              className="Header__suggestion-button"
              skin="transparent"
              text={this._checkPageLocationFoDisplayAllInCustomerName() ? 'TODAS' : activeCompany.name}
              icon="person"
              textCapitalize
              onClick={onCompanySelect}
            />
            <Icon
              className="Header__menu-icon Header__menu-icon--sm-only"
              name="person"
              onClick={onCompanySelect}
            />
          </div>
        }

        {
          this.state.suggestionsModalVisible &&
          <SuggestionModal
            onDismiss={this._toggleSuggestionsModal}
          />
        }

        {
          this.state.selectCompanyModalIsVisible &&
          <SelectCompanyModal
            onCompanySelect={this._onCompanySelect}
            onToggleCompanySelectModal={this._toggleSelectCompanyModal}
          />
        }
      </div>
    );
  }
}

export default withRouter(Header);
